import CustomField from "components/form/CustomField";
import { Form, Formik } from "formik";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Eye, EyeOff } from "lucide-react";

import {
  changePasswordSchema,
} from "utils/validations";
import { showAlert } from "store/slices/alertSlice";
import { changePassword } from "store/slices/authSlice";
import { handleSubmitForm } from "helpers/apiUtils";

function ChangePassword({ onCancel = () => {}, onSuccess = () => {} }) {
  const { t } = useTranslation();
  const { isLoading } = useSelector((state) => state.Auth);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const dispatch = useDispatch();
  const handleSubmitChangePassword = (values) => {
    const payload = {
      currentPassword: values.currentPassword,
      newPassword: values.confirmNewPassword,
    };

    handleSubmitForm({
      dispatch,
      action: changePassword,
      payload,
      onSuccess: () => {
        onSuccess();
        dispatch(
          showAlert({
            text: t(`Password changed successfully`),
            type: "success",
          }),
        );
      },
    });
  };

  return (
    <div className="change_password_modal">
      <Formik
        initialValues={{
          currentPassword: "",
          newPassword: "",
          confirmNewPassword: "",
        }}
        validationSchema={changePasswordSchema(t)}
        onSubmit={handleSubmitChangePassword}
      >
        {() => (
          <Form>
            <div className="form_field position-relative">
              <CustomField
                name="currentPassword"
                type={showOldPassword ? "text" : "password"}
                label={t("Current Password")}
                placeholder={t("Enter Current Password")}
                required
              />
              <span
                className="password_eye"
                onClick={() => setShowOldPassword((prev) => !prev)}
              >
                {showOldPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </span>
            </div>
            <div className="form_field position-relative">
              <CustomField
                name="newPassword"
                type={showPassword ? "text" : "password"}
                label={t("Password")}
                placeholder={t("Enter Password")}
                required
              />
              <span
                className="password_eye"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </span>
            </div>{" "}
            <div className="form_field position-relative">
              <CustomField
                name="confirmNewPassword"
                type={showConfirmPassword ? "text" : "password"}
                label={t("Confirm Password")}
                placeholder={t("Confirm New Password")}
                required
              />
              <span
                className="password_eye"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
              >
                {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </span>
            </div>
            <button
              type="submit"
              className="main_btn w-100 mt-3"
              disabled={isLoading}
            >
              {isLoading ? t("Changing password...") : t("Change password")}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default ChangePassword;
